import React from 'react';
import EmbededPowerBi from '../../components/EmbededPowerBI';
import { POWERBI_IDS } from '../../utils/Constant';

const ReportsPage: React.FunctionComponent = () => {
  return (
    <div className="dashboard-parent">
      <div className="report">
        <EmbededPowerBi
          groupId={POWERBI_IDS.groupId}
          reportId={POWERBI_IDS.reportId}
        />
      </div>
    </div>
  );
};

export default ReportsPage;
